import React from 'react'
import { Box } from '@mui/material'
import RoomServiceRoundedIcon from '@mui/icons-material/RoomServiceRounded'
import { CATERING } from '../../utils/catering'

/**
 * The small catering marker: cloche + label in the catering accent. Used on
 * catering categories, catering deals and anywhere else catering needs
 * pointing out. size "sm" is 20px tall, "md" 24px.
 */
const CateringBadge = ({ label = 'Catering', size = 'sm', sx }) => {
  const sm = size === 'sm'
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        height: sm ? 20 : 24,
        px: sm ? 0.875 : 1.125,
        borderRadius: '6px',
        bgcolor: CATERING.soft,
        color: CATERING.accent,
        border: `1px solid ${CATERING.border}`,
        fontSize: sm ? 11.5 : 12.5,
        fontWeight: 700,
        lineHeight: 1,
        letterSpacing: '0.01em',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        verticalAlign: 'middle',
        ...sx
      }}
    >
      <RoomServiceRoundedIcon aria-hidden sx={{ fontSize: sm ? 13 : 15, color: 'inherit' }} />
      {label}
    </Box>
  )
}

export default CateringBadge
